/**
 * Provides a type refinement for the `useEventsListener` hook
 * specifically for listening to recorder voice command events.
 */
import {
  Source,
  RecorderVoiceCommandProps as RecorderVoiceCommandPropsWrapper,
} from '@sironamedical/common/constants/crossTabEvents';
import { RecorderVoiceCommandProps } from 'domains/reporter/RichTextEditor';
import { NameSpaces, useCrossTabEventsListener } from 'modules/EventsManager';

export const useRecorderVoiceCommandEventsListener = (
  onEvent: ({
    source,
    payload,
  }: {
    source: Source;
    payload: RecorderVoiceCommandPropsWrapper<RecorderVoiceCommandProps>;
  }) => void
) =>
  useCrossTabEventsListener<RecorderVoiceCommandProps>(NameSpaces.RECORDER_VOICE_COMMAND, onEvent);
